import { Link } from 'react-router-dom'
import styles from './MyPage.module.css'

export default function MyPage() {
  // TODO: APIから取得
  const user = {
    nickname: 'ユーザー名',
    email: 'user@example.com',
    rating: 4.8,
    reviewCount: 10,
  }

  return (
    <div className={styles.container}>
      <div className={styles.profile}>
        <div className={styles.avatar}>
          <span>{user.nickname[0]}</span>
        </div>
        <div className={styles.info}>
          <h1>{user.nickname}</h1>
          <p className={styles.rating}>
            ★ {user.rating} ({user.reviewCount}件の評価)
          </p>
        </div>
      </div>

      <div className={styles.menu}>
        <Link to="/transactions" className={styles.menuItem}>
          <span>取引中の商品</span>
          <span>&gt;</span>
        </Link>
        <Link to="/mypage/listings" className={styles.menuItem}>
          <span>出品した商品</span>
          <span>&gt;</span>
        </Link>
        <Link to="/mypage/purchases" className={styles.menuItem}>
          <span>購入した商品</span>
          <span>&gt;</span>
        </Link>
        <Link to="/mypage/favorites" className={styles.menuItem}>
          <span>お気に入り</span>
          <span>&gt;</span>
        </Link>
        <Link to="/mypage/sales" className={styles.menuItem}>
          <span>売上管理</span>
          <span>&gt;</span>
        </Link>
        <Link to="/mypage/settings" className={styles.menuItem}>
          <span>設定</span>
          <span>&gt;</span>
        </Link>
      </div>
    </div>
  )
}
